export default {
    routerName: 'タグ詳細',
    tag: {
        icon: 'アイコン',
        name: 'タグ名',
        sortOrder: 'ソート',
        status: '状態',
        open: '有効',
        close: '無効',
        createBy: '作成者',
        createTime: '作成日付',
        updateBy: '更新者',
        updateTime: '更新日付',
    },
};
